module.exports = __webpack_public_path__ + "img/training.e5eba8c7.svg";